// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"67":"pagination","436":"slider","470":"snow","987":"countup"}[chunkId] || chunkId) + ".js?ver=" + {"67":"74fcbaf8ba2258a34000","436":"58fd1af15fe14294ef77","470":"eb7d59134f8f103639cd","487":"0f7648aa046e02ba4940","987":"f7fac3c5484444782037"}[chunkId] + "";
};